export default {
  id: 'chartjs_background_color',
  beforeDraw(chart, args, options){
    const {ctx, chartArea: {top, bottom, left, right, width, height}, scales: {x, y} } = chart;

    ctx.save();
    ctx.globalCompositeOperation = 'destination-over';
    ctx.fillStyle = options.color;
    const half_length = Math.ceil(options.stops.length / 2);
    for (let index = 0; index < half_length; index++) {
      const start = options.stops[2*index];
      const stop = options.stops[2*index+1];
      const a_left = left + (start*width);
      const a_right = stop ? left + (stop*width) : right;
      const a_width = a_right - a_left;
      ctx.fillRect(a_left, top, a_width, height);
    }
    ctx.restore();
  }
}